import { IAppState } from '../../../app.types';
import { generateResourceSelectors } from '../../generators/resource.selectors';
import { IMeetingSimple } from '../../meeting-simple/meeting-simple.types';
import * as types from './board.types';

export const boardSelectors = {
  ...generateResourceSelectors<types.IBoard>((state) => state.resource.board),
  selectResourcesByMeetingId: (state: IAppState, meetingId: IMeetingSimple['id']): types.IBoard[] => {
    const objects = Object.values(state.resource.board.byId) as types.IBoard[];
    return objects.filter((board: types.IBoard) => board.meetingIds.includes(meetingId));
  },
};
